import { render, staticRenderFns } from "./loaderWrapper.vue?vue&type=template&id=4e60daa7&scoped=true&lang=html&"
import script from "./loaderWrapper.vue?vue&type=script&lang=js&"
export * from "./loaderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./loaderWrapper.vue?vue&type=style&index=0&id=4e60daa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60daa7",
  null
  
)

export default component.exports